export default __webpack_public_path__ + "89df546e2f73e357ac6cedacbd78ffe6.woff2";